import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import ChangePasswordView from 'views/agent/configuration/changePassword/changePasswordView'; // Importing ChangePasswordView component

/**
 * Class representing the change password agent list view.
 * @extends JetView
 */
export default class changePasswordAgentListView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The layout configuration object.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for text translation
        const theme = this.app.config.theme; // Retrieve the current theme from app configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar component for the top section
                    css: theme, // Apply the current theme to the toolbar
                    elements: [
                        {
                            view: 'label', // Label component to display text
                            label: _('Cambiar Contraseña'), // Localized label text
                            width: 300, // Set width of the label
                        },
                    ],
                },
                ChangePasswordView, // Include the ChangePasswordView component
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            type: 'wide', // Set the layout type to wide
            cols: [left], // Define the columns layout with the left section
        };
    }
}

// FILE DOCUMENTED
